module.exports = __webpack_public_path__ + "static/media/Babi_Minamoto_Premium_Site.c8e608d4.jpeg";